import React from "react";


const Home: React.FC = () => <div style={{ margin: 20 }}>Home</div>

export default Home;